import { useTranslation } from 'react-i18next';

import type { IseeSessionsState } from '../../api/isee';
import { ErrorMessage } from '../common/ErrorMessage';
import type { IseeQueryState } from './cards-url-state';
import { IseeStudentPicker } from './IseeStudentPicker';

/** The ISEE picker, or why it cannot be shown yet. */
export function IseeRecipients({
  iseeEnabled,
  iseeSessions,
  query,
  onQueryChange,
}: {
  iseeEnabled: boolean;
  iseeSessions: IseeSessionsState;
  query: IseeQueryState;
  onQueryChange: (query: IseeQueryState) => void;
}) {
  const { t } = useTranslation();
  if (!iseeEnabled) {
    return <ErrorMessage message={t('cardGenerator.isee.disabled')} />;
  }
  if (iseeSessions.probing) {
    return (
      <p className="text-sm text-muted">
        {t('cardGenerator.source.iseeLoading')}
      </p>
    );
  }
  if (!iseeSessions.available) {
    return <ErrorMessage message={t('cardGenerator.source.iseeUnavailable')} />;
  }
  if (!iseeSessions.tree) {
    return null;
  }
  return (
    <IseeStudentPicker
      tree={iseeSessions.tree}
      query={query}
      onQueryChange={onQueryChange}
    />
  );
}
